export default __webpack_public_path__ + "static/taylor-bitmoji-a7f752174f8cf0ead322e4a14e27f975.png";